export const getFileNameExtension = (fileName: string) => {
  const index = fileName.lastIndexOf(".");
  if (index < 1 || index === fileName.length - 1) return undefined;
  return fileName.substring(index + 1);
};
